export const getters = {
  financeBuyers: state => state.financesList.map(finance => finance.buyer),
  financeSellers: state => state.financesList.map(finance => finance.seller),
  hasNegativeBalance: state => state.personalAccount.balance < 0,
}
